import { render, staticRenderFns } from "./ProductEditTabDocuments.vue?vue&type=template&id=5c18ee17&"
import script from "./ProductEditTabDocuments.vue?vue&type=script&lang=js&"
export * from "./ProductEditTabDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports